<template>
  <v-container fluid class="max-width docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sale Invoices</v-toolbar-title>
        <v-spacer></v-spacer>
           <v-btn color="primary" class="mt-2" small to="/new-export-invoice">
            <v-icon left dark>mdi-plus</v-icon>Create New Invoice
          </v-btn>
      </v-toolbar>
      <v-card-text>

        <v-row dense class="mt-4">
          <!-- datepicker 1 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="StartDate" label="From"
                  prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="StartDate" @input="onStartDateChange"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="EndDate" label="To"
                  prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="EndDate" @input="onEndDateChange"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col cols="12">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
              dense outlined hide-details></v-text-field>
          </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="dailySales" :search="search">

              <template v-slot:item.DocTotal="{ item }">
                <div style="width: 100px">{{ item.CurrencySymbol }} {{ item.DocTotal | currency }}</div>
              </template>

                <template v-slot:item.ConvertedTotal="{ item }">
                <div style="width: 100px">{{ item.ConvertedTotal | currency }}</div>
              </template>
              
              <template v-slot:item.TotalGeneralCost="{ item }">
                <div style="width: 100px">{{ item.TotalGeneralCost | currency }}</div>
              </template>

              <template v-slot:item.Margin="{ item }">
                <div style="width: 100px">{{ (item.ConvertedTotal - item.TotalGeneralCost) | currency }}</div>
              </template>

              <template v-slot:item.Date="{ item }">
                <div style="width: 100px">{{ item.Date | date }}</div>
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn text @click="openPreview(item.id)" color="accent">
                  <v-icon left>mdi-eye</v-icon> More Details
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Bottom Sheet Modal for Invoice Preview -->
    <v-dialog v-model="previewSheet" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="grey lighten-3">
        <v-toolbar dense flat color="primary" dark elevation="2">
          <v-icon left>mdi-file-document-outline</v-icon>
          <v-toolbar-title>Invoice Preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="previewSheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="height: calc(100vh - 48px); overflow-y: auto;">
          <v-container fluid>
            <v-row justify="center">
              <v-col cols="12" md="10" lg="10" xl="8">

                <!-- Action Button -->
                <v-card class="my-4 elevation-2" v-if="selectedInvoice">
                  <v-card-text class="py-3">
                    <v-btn @click="generateInvoice" color="accent" text>
                      <v-icon left>mdi-file-pdf-box</v-icon>Generate Invoice
                    </v-btn>
                    <v-btn :to="`/edit-export-invoice/${selectedInvoice.id}`" color="primary" text>
                      <v-icon left>mdi-pencil</v-icon>Edit Invoice
                    </v-btn>
                  </v-card-text>
                </v-card>

                <!-- Invoice Details Card -->
                <v-card class="mb-4 elevation-2" v-if="selectedInvoice">
                  <v-card-title class="secondary py-3">
                    <v-icon left>mdi-information-outline</v-icon>
                    <span class="text-h6 font-weight-bold">Invoice Information</span>
                  </v-card-title>
                  <v-card-text class="pa-4">
                    <v-row class="subtitle-2">
                      <v-col cols="12" md="5">
                        <v-simple-table dense>
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td class="font-weight-bold black--text">Date:</td>
                                <td class="black--text">{{ selectedInvoice.CreatedAt | date }}</td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold black--text">Invoice#:</td>
                                <td class="black--text">{{ selectedInvoice.DocNum }}</td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold black--text">Client:</td>
                                <td class="black--text">{{ selectedInvoice.Customer && selectedInvoice.Customer.Name }}</td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold black--text">Total Freight Cost:</td>
                                <td class="black--text">{{ selectedInvoice.TotalFreightCost | currency }}</td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold black--text">Advance Payment:</td>
                                <td class="black--text">{{ selectedInvoice.AdvancePayment | currency }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>

                      <v-col cols="12" md="2"></v-col>

                      <v-col cols="12" md="5">
                        <v-simple-table dense>
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td class="font-weight-bold black--text">Total Bill:</td>
                                <td class="font-weight-bold black--text">{{ selectedInvoice.CurrencySymbol }} {{ selectedInvoice.DocTotal | currency }}</td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold black--text">Total Bill (LC):</td>
                                <td class="font-weight-bold black--text">Ksh {{ selectedInvoice.ConvertedTotal | currency }}</td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold black--text">Total Cost:</td>
                                <td class="font-weight-bold black--text">Ksh {{ selectedInvoice.TotalGeneralCost | currency }}</td>
                              </tr>
                              <tr class="success lighten-4">
                                <td class="font-weight-bold black--text">Margin:</td>
                                <td class="font-weight-bold success--text text--darken-3">
                                  Ksh {{ (selectedInvoice.ConvertedTotal - selectedInvoice.TotalGeneralCost) | currency }}
                                </td>
                              </tr>
                              <tr class="success lighten-4">
                                <td class="font-weight-bold black--text">Margin %:</td>
                                <td class="font-weight-bold success--text text--darken-3">
                                  {{ marginPercentage }}%
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Sale Items Card -->
                <v-card class="mb-4 elevation-2" v-if="previewSaleRows.length > 0">
                  <v-card-title class="secondary py-3">
                    <v-icon left>mdi-cart-outline</v-icon>
                    <span class="text-h6 font-weight-bold">Invoice Items</span>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-data-table dense light :mobile-breakpoint="0" :items-per-page="100" :headers="previewHeaders"
                      :items="previewSaleRows" item-key="id" hide-default-footer class="black--text text-left">
                      <template v-slot:item.itemCode="{ item }">
                        <span class="black--text font-weight-medium text-left">{{ item.itemCode }}</span>
                      </template>
                      <template v-slot:item.Name="{ item }">
                        <span class="black--text font-weight-medium text-left" style="width: 200px">{{ item.product.Name }}</span>
                      </template>
                      <template v-slot:item.Quantity="{ item }">
                        <span class="black--text font-weight-medium text-left">{{ item.Quantity }}</span>
                      </template>
                      <template v-slot:item.UOM.UomName="{ item }">
                        <span class="black--text font-weight-medium text-left">{{ item.UOM && item.UOM.UomName }}</span>
                      </template>
                      <template v-slot:item.Price="{ item }">
                        <span class="black--text font-weight-medium text-left" v-if="item.Price">{{ item.Price | currency }}</span>
                      </template>
                      <template v-slot:item.LineTotal="{ item }">
                        <span class="black--text font-weight-medium text-left">{{ item.LineTotal | currency }}</span>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>

                <!-- Cost Variables Card -->
                <v-card class="mb-4 elevation-2" v-if="previewSaleCosts.length > 0">
                  <v-card-title class="secondary py-3">
                    <v-icon left>mdi-currency-usd</v-icon>
                    <span class="text-h6 font-weight-bold">Cost Variables</span>
                  </v-card-title>
                  <v-card-text class="pa-4">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-data-table dense light :mobile-breakpoint="0" :items-per-page="100"
                          :headers="costHeaders" :items="previewSaleCosts" item-key="id" hide-default-footer class="black--text text-left">
                          <template v-slot:item.costVariable.Name="{ item }">
                            <span class="black--text font-weight-medium text-left">{{ item.costVariable && item.costVariable.Name }}</span>
                          </template>
                          <template v-slot:item.Price="{ item }">
                            <span class="black--text font-weight-medium text-left" v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- PDF Preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>

  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data: () => ({
    search: "",
    dailySales: [],
    totalSales: 0,
    date: new Date().toISOString().substr(0, 10),
    StartDate: new Date().toISOString().substr(0, 10),
    EndDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    loader: false,
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Customer", value: "CustomerName" },
      { text: "No of Boxes", value: "NoOfBoxes" },
      { text: "Total Weight", value: "TotalWeight" },
      { text: "Total Amount", value: "DocTotal" },
      { text: "Total (LC)", value: "ConvertedTotal" },
      { text: "Total Cost", value: "TotalGeneralCost" },
      { text: "Margin", value: "Margin" },
      { text: "Date", value: "Date" },
      { text: "View Details", value: "action" },
    ],
    recordsData: [],
    previewSheet: false,
    selectedInvoice: null,
    previewSaleRows: [],
    previewSaleCosts: [],
    previewHeaders: [
      { text: "Hs Code", value: "itemCode" },
      { text: "Product", value: "Name" },
      { text: "Qty (Boxes)", value: "Quantity" },
      { text: "Unit", value: "UOM.UomName" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ],
    costHeaders: [
      { text: "Item Name", value: "costVariable.Name" },
      { text: "Amount", value: "Price" }
    ],
  }),
  computed: {
    marginPercentage() {
      if (!this.selectedInvoice || !this.selectedInvoice.ConvertedTotal || this.selectedInvoice.ConvertedTotal === 0) {
        return '0.00';
      }
      const margin = this.selectedInvoice.ConvertedTotal - this.selectedInvoice.TotalGeneralCost;
      const percentage = (margin / this.selectedInvoice.ConvertedTotal) * 100;
      return percentage.toFixed(2);
    }
  },
  methods: {
    getRecords() {
      let data = {};
      data.StartDate = this.StartDate;
      data.EndDate = this.EndDate;
      data.combinedReport = "N";
      data.saleType = this.saleType;
      const self = this;
      var url = "";

      url = `/export-invoices`;

      this.loader = true;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dailySales = res.ResponseData.sales;
            self.totalSales = res.ResponseData.totalSales;
            self.loader = false;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.loader = false;
          self.$store.commit("loader", false);
        });
    },
    openPreview(invoiceId) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/export-sales-invoice/${invoiceId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            var invoice = res.ResponseData;
            self.selectedInvoice = invoice.Invoice;
            self.previewSaleRows = invoice.SaleRows;
            self.previewSaleCosts = invoice.SaleCosts;
            self.previewSheet = true;
            self.$store.commit("loader", false);
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    generateInvoice() {
      if (!this.selectedInvoice) return;

      var url = "/print-supermarket-invoice-document/14/" + this.selectedInvoice.id;
      const apiUrl = `${host}${url}`;
      const self = this;

      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      }).catch(() => {
        self.$refs.snackbar.show("Error generating invoice", "red");
      });
    },
    onStartDateChange() {
      this.menu1 = false;
      this.getRecords();
    },
    onEndDateChange() {
      this.menu2 = false;
      this.getRecords();
    },
  },
  created() {
    this.getRecords();
  },
};
</script>